// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bKDV","footer":"styles_footer__1RZSl","passCodeTooltip":"styles_passCodeTooltip__1qCkV"};